import React from 'react';
import { func, string, bool, node } from 'prop-types';
import cn from 'classnames';
import Button from './Button';
import './stylesheets/TextSubmitForm.scss';

class TextSubmitForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: props.initialValue,
      focused: false
    };

    this.input = null;

    this.captureRefToInput = (input) => {
      this.input = input;
    };

    this.moveCursorToEnd = () => {
      if (this.input) {
        this.input.selectionStart = this.state.inputValue.length || 0;
        this.input.selectionEnd = this.state.inputValue.length || 0;
      }
    };

    this.updateInputValue = (e) => {
      if (this.props.onChangeCallback) {
        this.props.onChangeCallback(e.target.value);
      }
      this.setState({ inputValue: e.target.value });
    };

    this.submitInputValue = (e) => {
      if (this.props.submitInputValue) {
        e.preventDefault();
        if (this.state.inputValue !== '' || this.props.allowEmptySubmitValue) {
          this.props.submitInputValue(this.state.inputValue);

          if (this.props.clearInputOnSubmit) {
            this.setState({ inputValue: '' });
          }
        }
      }
    };

    this.onFocus = (e) => {
      if (this.props.onFocusCallback) {
        this.props.onFocusCallback(e.target.value);
      }
      this.setState({ focused: true });
    };

    this.onBlur = (e) => {
      if (this.props.onBlurCallback) {
        this.props.onBlurCallback(e.target.value);
      }
      if (this.props.clearInputOnBlur) {
        this.setState({ inputValue: '' });
      }
      this.setState({ focused: false });
    };
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.moveCursorToEnd();
    }
  }

  clearInputNoPropagation = (e) => {
    e.stopPropagation();
    this.setState({ inputValue: '' });
  }

  submitInputValueNoPropagation = (e) => {
    e.stopPropagation();
    this.submitInputValue(e);
  }

  render() {
    const {
      focusedPlaceholder,
      placeholder,
      className,
      type,
      showControlButtons,
      allowEmptySubmitValue,
      buttonText
    } = this.props;
    const { focused, inputValue } = this.state;
    const rootClassName = 'TextSubmitForm';

    const classNames = cn(rootClassName, className, {
      [`${rootClassName}--focused`]: focused,
      [`${rootClassName}--hasInput`]: inputValue
    });

    const placeholderText = this.state.focused && focusedPlaceholder || placeholder;
    const focusInput = { onClick: () => this.input && this.input.focus() };
    return (
      <div className={classNames} {...focusInput}>
        <form onSubmit={this.submitInputValue}>
          { this.props.childBeforeInput }
          <input
            placeholder={placeholderText}
            type={type}
            value={this.state.inputValue}
            onChange={this.updateInputValue}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            autoFocus={this.props.autoFocus || this.props.forceFocus}
            ref={this.captureRefToInput}
          />
          { this.props.children }
        </form>
        {
          showControlButtons &&
          <div className={cn('TextSubmitForm__ButtonsContainer', { visible: focused || inputValue })}>
            <Button
              className="TextSubmitForm__Button TextSubmitForm__CancelButton"
              onClick={this.clearInputNoPropagation}
              size="small"
              tabIndex="-1"
            >
              Cancel
            </Button>
            <Button
              className="TextSubmitForm__Button TextSubmitForm__SubmitButton"
              onClick={this.submitInputValueNoPropagation}
              disabled={!(inputValue || allowEmptySubmitValue)}
              size="small"
              tabIndex="-1"
            >
              {buttonText}
            </Button>
          </div>
        }
      </div>
    );
  }
}

TextSubmitForm.propTypes = {
  submitInputValue: func,
  allowEmptySubmitValue: bool,
  clearInputOnSubmit: bool,
  onChangeCallback: func,
  onFocusCallback: func,
  onBlurCallback: func,
  clearInputOnBlur: bool,
  placeholder: string,
  focusedPlaceholder: string,
  initialValue: string,
  autoFocus: bool,
  childBeforeInput: node,
  type: string,
  children: node,
  showControlButtons: bool,
  buttonText: string
};

TextSubmitForm.defaultProps = {
  submitInputValue: () => {},
  allowEmptySubmitValue: false,
  placeholder: 'Create new',
  clearInputOnSubmit: false,
  clearInputOnBlur: false,
  initialValue: '',
  autoFocus: false,
  type: 'text',
  showControlButtons: false
};

export default TextSubmitForm;



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/TextSubmitForm.jsx